import { render, staticRenderFns } from "./warning_standart.vue?vue&type=template&id=8f75cd30&scoped=true&"
import script from "./warning_standart.vue?vue&type=script&lang=js&"
export * from "./warning_standart.vue?vue&type=script&lang=js&"
import style0 from "./warning_standart.vue?vue&type=style&index=0&id=8f75cd30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f75cd30",
  null
  
)

export default component.exports